export default function EhoBadge({ size = "md", showLabel = true }) {
  const widths = { sm: 56, md: 100, lg: 140 };
  const width  = widths[size] ?? 80;

  return (
    <div className={`eho-badge eho-badge--${size}`}>
      <a
        href="https://ratings.food.gov.uk/business/1895611/teardrop"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="View TearDrop Hydroponics food hygiene rating on the FSA website"
      >
        <img
          src="https://ratings.food.gov.uk/images/badges/fhrs/3/fhrs-badge-5.svg"
          alt="Food Hygiene Rating 5 out of 5 - Very Good, awarded by Rochford Council Environmental Health"
          width={width}
          height="auto"
          loading="lazy"
          decoding="async"
          style={{ display: "block", width, height: "auto" }}
        />
      </a>
      {showLabel && (
        <p className="eho-badge__label">
          Rochford Council EHO
        </p>
      )}
    </div>
  );
}